import { Component, OnInit, HostListener, AfterViewInit, Input, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SidebarService } from '../../Services/sidebar-service.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { LogoutmodelComponent } from '../header/logoutmodel/logoutmodel.component';
import { UtilsService } from '../../Services/utils.service';
import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-side-bar',
  imports: [
    RouterModule,
    CommonModule,
    LogoutmodelComponent,
    FontAwesomeModule,
  ],
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss',
})
export class SideBarComponent implements OnInit, AfterViewInit {
  @Input() mode: 'dashboard' | 'landing' = 'dashboard';
  @Output() createAccount = new EventEmitter<void>();
  @Output() signIn = new EventEmitter<void>();

  isSidebarOpen = typeof window === 'undefined' || window.innerWidth >= 800;
  isMobile = false;
  faHouse = faHouse;
  // profileImage = 'https://cmax-2.pages.dev/assets/icons/profileimage.png';
  profileImage: string = '';
  userName: any;
  email: any;
  constructor(
    private sidebarService: SidebarService,
    private router: Router,
    private utilsService: UtilsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    this.sidebarService.sidebarOpen$.subscribe((isOpen) => {
      this.isSidebarOpen = isOpen;
    });
    this.checkScreenSize();
  }
  ngAfterViewInit(): void {
    setInterval(() => {
      this.profileImage =
        localStorage.getItem('profileImage') ?? 'https://cmax-2.pages.dev/assets/icons/profileimage.png';
      this.userName = localStorage.getItem('userName') ?? '';
      this.email = localStorage.getItem('email') ?? '';
    }, 2000);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 800; // Adjust the width as needed
  }

  RedirectToGuidelines() {
    this.router.navigate(['/dashboard/GuideLines']);
  }
  RedirectToSetting() {
    this.router.navigate(['/dashboard/edit-profile']);
  }

  closeSidebar() {
    if (this.isMobile) {
      this.sidebarService.toggleSidebar();
    }
  }

  closeSidebarMobile() {
    if (this.isMobile) {
      this.sidebarService.toggleSidebar();
    }
  }
  isLogoutModalOpen: boolean = false;
  closeLogoutModal() {
    this.isLogoutModalOpen = false;
  }
  logout() {
    this.utilsService.triggerLogoutFunction();
  }
  showLogoutModal() {
    this.isLogoutModalOpen = true;
    if (this.isMobile) {
      this.isSidebarOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const sidebar = document.querySelector('.mobile'); // Use the actual class name

    // Check if sidebar is not null before calling contains
    if (this.isMobile && sidebar && this.isSidebarOpen && !sidebar.contains(target)) {
      this.isSidebarOpen = false; // Close the sidebar if clicked outside
    }
  }

  // * Router navigation function
  redirectTo(path: string) {
    this.router.navigate([path]);
    this.utilsService.toggleComponentVisibility(false);
  }

  isActive(path: string): boolean {
    return this.router.url === path;
  }
  RedirectToWallet() {
    this.router.navigate(['/dashboard/wallet']);
    this.closeSidebar();
  }

  RedirectToScratchCard() {
    this.utilsService.toggleComponentVisibility(false);
    this.closeSidebarMobile();
  }
  redirectToGame(path: string) {
    this.router.navigate([path]);
    this.utilsService.toggleComponentVisibility(false);
    this.closeSidebarMobile();
  }
  isTreasurePickRoute(): boolean {
    const current = this.router.url;
    return current === '/dashboard/TreasurePick' || current === '/dashboard/StackBuilder' || current === '/dashboard/Avatar' || current === '/dashboard/Baccaret' || current === '/dashboard/Keno' || current === '/dashboard/Roulette' || current === '/dashboard/Mines' || current === '/dashboard/Plinko';
  }

  isLandingSectionActive(section: 'dashboard' | 'trending' | 'privacy' | 'terms'): boolean {
    const url = this.router.url;
    switch (section) {
      case 'dashboard':
        return url === '/' || url === '';
      case 'trending':
        return url === '/trending-games';
      case 'privacy':
        return url === '/PrivacyPolicy';
      case 'terms':
        return url === '/Terms&Conditions' || url === '/Terms&Condition';
      default:
        return false;
    }
  }

  goToLandingDashboard() {
    this.router.navigate(['/']);
    this.closeSidebar();
  }

  goToTrendingGames() {
    this.router.navigate(['/trending-games']);
    this.closeSidebar();
  }

  goToPrivacyPolicy() {
    this.router.navigate(['/PrivacyPolicy']);
    this.closeSidebar();
  }

  goToTermsAndConditions() {
    this.router.navigate(['/Terms&Conditions']);
    this.closeSidebar();
  }

  onCreateAccount() {
    this.closeSidebar();
    if (this.createAccount.observed) {
      this.createAccount.emit();
    } else {
      this.router.navigate(['/SignUp']);
    }
  }

  onSignIn() {
    this.closeSidebar();
    if (this.signIn.observed) {
      this.signIn.emit();
    } else {
      this.router.navigate(['/login']);
    }
  }
}
